import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import { SalesPlan } from "../../../common/SalesPlan";
import * as fromRootStore from "../../../reducers";
import { FinyearService, SalesPlanService } from "../../../services/index";
declare var google;

@Component({
  selector: "plan-details",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./plandetails.component.html",
})
export class PlandetailsMasterComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Input() _params: any;
  rv: Boolean = false;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  finyear: any;
  agent: any;
  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    let invdata = Object.assign({}, val["data"]);
    // delete invdata['invdet'];
    this.planData = invdata;

    // this.invdata.invdt = new Date(('' + this.invdata.invdt).replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
  }

  get params(): any[] {
    return this._params;
  }

  isLoadMask: Promise<any>;
  finyearList: any[];
  seasonList: any[];
  loadingIndicator: boolean = true;
  mode: any;

  isLoading: boolean = false;
  viewMode = "LOAD";
  planData: any;
  data: any;

  constructor(
    public store: Store<fromRootStore.State>,
    private salesplanService: SalesPlanService,
    public toasterService: ToasterService,
    private finyearService: FinyearService
  ) {}

  ngOnInit(): void {
    this.data = {
      sp_id: 0,
      fin_id: 0,
      seasoncombo: [],
      fin_year: "2018-2019",
      sales_target: 0,
      order_per: 0,
      order_target: 0,
      seasons: [],
      agents: [],
      list: [],
      plan_details: [],
    };
    this.LoadFinYearList();
    this.LoadSeasonList();
    this.initData();
    this.process();
  }

  initData() {
    this.process();
  }
  viewPartyWise(data) {
    this.isLoading = true;
    this.agent = data;
    this.viewMode = "PARTY";
    this.refreshTotal(this.agent);
    this.viewAdjust();
  }
  viewAgentWise() {
    this.isLoading = true;
    this.viewMode = "AGENT";
    this.viewAdjust();
  }

  setTableColumnsWidth(viewType = "sptrans") {
    const b = document.querySelector("." + viewType + " .sp-cf");
    b["onscroll"] = function () {
      const h = document.querySelector("." + viewType + " .sp-ch"),
        f = document.querySelector("." + viewType + " .sp-cf"),
        b = document.querySelector("." + viewType + " .sp-cb");
      h.scrollLeft = f.scrollLeft;
      b.scrollLeft = f.scrollLeft;
    };
    let ht = document.querySelector("." + viewType + " #sp-header-tab");
    let width = ht["offsetWidth"] + 15;
    $("." + viewType + " .sp-body-div").css({ width: width + "px" });
  }
  viewAdjust() {
    let that = this;
    that.isLoading = true;
    setTimeout(function () {
      that.setTableColumnsWidth("sptrans");
      that.isLoading = false;
    }, 200);
  }
  loadData() {
    this.viewMode = "LOAD";
    let params = {
      fin_id: this.data.fin_id,
      finyear: this.data.finyear,
      season_id: this.data.season_id,
      season: this.data.season,
      sp_id: this.data.sp_id,
      sales_target: this.data.sales_target,
      order_per: this.data.order_per,
      order_target: this.data.order_target,
    };
    let that = this;
    this.isLoading = true;
    this.salesplanService.getSalesPlanDetails(params).then((res: any) => {
      this.isLoading = false;

      that.data = res;
      that.process();
      that.viewMode = "AGENT";
      that.viewAdjust();
    });
    this.initData();
  }

  moveIt(id: string, key: string, it) {
    if (id.search("spd-") > -1) {
      let inds = id.split("-"),
        xlen = (this.data["seasons"].length + 1) * 2,
        ylen = (this.data["agents"].length + 1) * 2,
        x = parseInt(inds[2]),
        y = parseInt(inds[1]);
      switch (key) {
        case "Down":
          y++;
          break;
        case "Up":
          y--;
          break;
        case "Right":
        case "Enter":
          x++;
          break;
        case "Left":
          x--;
          break;
        default:
          return;
      }
      if (x < 0) {
        x = xlen - 1;
      } else if (x >= xlen) {
        x = 0;
        y++;
      }
      if (y < 0) {
        y = ylen - 1;
      } else if (y >= ylen) {
        y = 0;
        x = 0;
      }
      let target = "#spd-" + y + "-" + x,
        el = $(target);
      if (el) {
        event.preventDefault();
        el.select();
        let offset = el.offset();
        $("#sp-scrollable").scrollTop(y * 30 - 50);
        $("#sp-scrollable").scrollLeft(offset.left);
      } else {
        console.log("#spd-" + y + "-" + x);
        if (it++ < 10) {
          this.moveIt(target, key, it);
        }
      }
    }
  }
  hotkeys(event) {
    let id = event.srcElement.id || "",
      key = event.keyIdentifier;
    /*if(key=='Enter'){
                this.onSaveSalesPlan();
            return;
        }*/
    this.moveIt(id, key, 0);
  }

  trackByIndex(index: number, value: number) {
    return index;
  }

  calcOT(q, p) {
    let r = 0;
    q = this.ifNaN(q);
    p = this.ifNaN(p);
    if (p > 0) {
      //   r = Math.round (q / p * 100);
      r = (q / p) * 100;
    } else {
      r = q;
    }
    return this.ifNaN(r);
  }

  findOT(data) {
    let st = data.sales_target,
      op = data.order_per;
    data.order_target = this.calcOT(st, op);
  }
  round(no) {
    no = isNaN(parseFloat(no)) ? 0 : parseFloat(no);
    return Math.round(no * 100) / 100;
  }

  calcSP(ot, ao) {
    return this.ifNaN(this.round((ot / ao) * 100));
  }

  findSP(data) {
    let ot = data.order_target,
      ao = data.actual_order;
    data.sales_per = this.calcSP(ot, ao);
  }

  calc(row, s_id) {
    this.process();
  }
  ifNaN(no) {
    no = isNaN(no) ? 0 : no;
    return no;
  }

  calcOP(ptype = "data") {
    this.applyOP(this.data, "data");
    this.process();
  }

  applyOP(data, ptype) {
    let seasons = data.seasons,
      op = data.order_per,
      agents = ptype == "data" ? data.agents : data.party;
    for (let i = 0; i < seasons.length; i++) {
      seasons[i].order_per = op;
    }

    for (let i = 0; i < agents.length; i++) {
      let agent = agents[i];
      agent.order_per = op;
      /*    if(ptype=='data') {
                    this.applyOP(agents[i],'agent');
                }*/
      for (let j = 0; j < agent.seasons.length; j++) {
        agent.seasons[j].order_per = op;
      }

      for (let j = 0; j < agent.party.length; j++) {
        let party = agent.party[j];
        party.order_per = op;
        for (let k = 0; k < party.seasons.length; k++) {
          party.seasons[k].order_per = op;
        }
      }
    }
  }

  calcOPASeason(s_id) {
    this.process();
  }
  calcOPAgent(a_ind) {
    this.process();
  }
  calcOPPSeason(s_id) {
    this.process();
  }
  calcOPParty(a_ind) {
    this.process();
  }

  findTotalDiff(list, ST, OT) {
    for (let i = 0; i < list.length; i++) {
      const li = list[i],
        st = li.sales_target,
        ot = li.order_target;
      ST += this.ifNaN(st);
      OT += this.ifNaN(ot);
    }

    return {
      st: ST,
      ot: OT,
    };
  }

  refreshTotal(data) {
    let agents = data.agents ? data.agents : data.party,
      seasons = data.seasons;
    if (data.name == "DIRECT1") {
      //
    }
    // OT = (data.agents)?data.order_target : data.actual_order,
    let st = 0,
      ot = 0,
      ao = 0,
      sp = 0;
    //Season loop
    for (let i = 0; i < seasons.length; i++) {
      let s = seasons[i];
      st += this.ifNaN(s.sales_target);
      ot += this.ifNaN(s.order_target);
      ao += this.ifNaN(s.actual_order);
      sp += this.ifNaN(s.sales_per);

      let sst = 0,
        sot = 0,
        sao = 0,
        ssp = 0;
      for (let j = 0; j < agents.length; j++) {
        let as = agents[j].seasons[i];
        (sst += this.ifNaN(as.sales_target)),
          (sot += this.ifNaN(as.order_target));
        (ssp += this.ifNaN(as.sales_per)), (sao += this.ifNaN(as.actual_order));
      }
      //  s.sales_per = this.calcSP(OT,s.actual_order);
      // console.log(OT," ; ", s.actual_order, " : ",s.sales_per);
      s.sw_st = this.ifNaN(sst);
      s.sw_ot = this.ifNaN(sot);
      s.sw_sp = this.ifNaN(ssp);
      s.sw_ao = this.ifNaN(sao);
      s.swd_st = this.ifNaN(s.sales_target - sst);
      s.swd_ot = this.ifNaN(s.order_target - sot);
    }
    data.sw_st = this.ifNaN(st);
    data.sw_ot = this.ifNaN(ot);
    data.sw_ao = this.ifNaN(ao);
    data.sw_sp = this.ifNaN(sp);

    data.swd_st = this.ifNaN(data.sales_target - st);
    data.swd_ot = this.ifNaN(data.order_target - ot);
    data.swd_ao = this.ifNaN(data.actual_order - ao);
    // data.swd_sp = this.ifNaN(data.sales_per - sp);

    //Agent Loop
    (st = 0), (ot = 0), (sp = 0), (ao = 0);
    for (let i = 0; i < agents.length; i++) {
      let a = agents[i],
        sst = 0,
        sot = 0,
        ssp = 0,
        sao = 0;
      (st += a.sales_target), (ot += a.order_target), (sp += a.sales_per);
      for (let j = 0; j < seasons.length; j++) {
        let s = seasons[j];
        sst += this.ifNaN(a.seasons[j].sales_target);
        ssp += this.ifNaN(a.seasons[j].sales_per);
        sao += this.ifNaN(a.seasons[j].actual_order);
        sot += this.ifNaN(a.seasons[j].order_target);
        // s.sales_per = this.calcSP(OT, s.actual_order);
      }
      a.aw_st = this.ifNaN(sst);
      a.aw_ao = this.ifNaN(sao);
      a.aw_sp = this.ifNaN(ssp);
      a.aw_ot = this.ifNaN(sot);
      a.awd_st = this.ifNaN(a.sales_target - sst);
      a.awd_ot = this.ifNaN(a.order_target - sot);
    }

    data.aw_st = this.ifNaN(st);
    data.aw_ot = this.ifNaN(ot);
    data.aw_sp = this.ifNaN(sp);
    console.log(data);
  }

  roundOff(no) {
    no = isNaN(no) ? 0 : no;
    no = Math.round(no * 100) / 100;
    return no;
  }

  doRoundOff(data) {}
  process() {
    SalesPlan.doCalc(this.data);
    return;
  }
  abu() {
    let data = this.data,
      agents = data.agents,
      seasons = data.seasons,
      aw_st = 0,
      aw_ot = 0;
    this.findOT(data);
    // this.findSP(data);

    let ao = data.actual_order,
      ot = data.order_target,
      sp = this.calcSP(ot, data.order_target),
      aw_sp = 0,
      aw_ao = 0;

    //Season List
    for (let i = 0; i < seasons.length; i++) {
      let season = seasons[i];
      this.findOT(season);
      season.sales_per = this.calcSP(season.order_target, data.order_target);
    }

    //Agent List
    for (let i = 0; i < agents.length; i++) {
      let agent = agents[i],
        st = agent.sales_target,
        ot = agent.order_target,
        ao = agent.actual_order,
        sp = agent.sales_per,
        partyList = agent.party,
        agentSeasons = agent.seasons;
      this.findOT(agent);
      agent.sales_per = this.calcSP(agent.order_target, data.order_target);
      aw_st += this.ifNaN(st);
      aw_ot += this.ifNaN(ot);
      aw_ao += this.ifNaN(ao);
      aw_sp += this.ifNaN(sp);

      //Agent Season List
      for (let j = 0; j < agentSeasons.length; j++) {
        let season = agentSeasons[j];
        this.findOT(season);
        season.sales_per = this.calcSP(
          season.order_target,
          seasons[j].order_target
        );
      }

      //Agent Party wise
      for (let j = 0; j < partyList.length; j++) {
        let party = partyList[j],
          partySeasons = party.seasons;
        party.sales_per = this.calcSP(party.order_target, agent.order_target);
        this.findOT(party);

        //Party Season List
        for (let k = 0; k < partySeasons.length; k++) {
          let season = partySeasons[k];
          this.findOT(season);
          season.sales_per = this.calcSP(
            season.order_target,
            agent.seasons[k].order_target
          );
        }
      }
      this.refreshTotal(agent);
    }

    data.aw_st = this.ifNaN(aw_st);
    data.aw_ot = this.ifNaN(aw_ot);
    data.aw_ao = this.ifNaN(aw_ao);
    data.aw_sp = this.ifNaN(aw_sp);

    data.a_st = this.ifNaN(aw_st);
    data.a_ot = this.ifNaN(aw_ot);
    data.a_ao = this.ifNaN(aw_ao);
    data.a_sp = this.ifNaN(aw_sp);

    data.awd_st = this.ifNaN(data.sales_target - aw_st);
    data.awd_ot = this.ifNaN(data.order_target - aw_ot);
    data.awd_ao = this.ifNaN(data.actual_order - aw_ao);
    data.awd_sp = this.ifNaN(data.sales_per - aw_sp);
    this.refreshTotal(this.data);
    window["data"] = this.data;
    console.log(this.data);

    if (this.viewMode == "PARTY") {
      this.refreshTotal(this.agent);
    }
  }

  displayFn(val) {
    if (val && val.fin_id) {
      this.data.fin_id = val.fin_id;
      this.data.finyear = val.finyear;
      this.loadData();
      return val.finyear;
    }
    return "";
  }

  onSaveSalesPlan(): void {
    let that = this;
    debugger;
    let params = {
      data: JSON.stringify(that.data),
    };

    this.isLoading = true;
    this.salesplanService
      .onSaveSalesPlan(params)
      .then(function (res: any) {
        that.isLoading = false;
        if (res.success) {
          //   that.bsModalRef.hide();
          //    that.partyUpdateEvent.emit();
          that.toasterService.pop({
            bodyOutputType: 1,
            type: "success",
            title: "DONE",
            body: "Changes has been saved!",
          });
        } else {
          swal("ERROR", res.message, "error");
        }
      })
      .catch(function (error: any) {
        that.isLoading = false;
        let res = JSON.parse(error._body);
        swal("ERROR", res.message, "error");
        //console.log(error);
      });
  }

  onTest() {
    console.log(this.data);
  }

  LoadFinYearList() {
    let that = this;
    this.finyearService.getFinYearList({}).then((res: any) => {
      that.finyearList = res.data;
      //////
      that.data.fin_id = res.data[0].fin_id;
      that.finyearCtrl.setValue(res.data[0]);
      that.loadData();
    });
  }

  LoadSeasonList() {
    let that = this;
    this.finyearService.getSeasonList({}).then((res: any) => {
      that.seasonList = res.data;
      //////
      that.data.fin_id = res.data[0].fin_id;
      that.seasonCtrl.setValue(res.data[0]);
      that.loadData();
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/Plandetails/plandetails.component.ts